export default __webpack_public_path__ + "static/media/04.2edf578c.png";